/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import styles from './MuscQuickStartGuide.module.scss';
import MuscQuickStartGuideText from './MuscQuickStartGuideText';

export default function MuscQuickStartPopover({ handleDialog }: { handleDialog: () => void }) {
  return (
    <Modal id="mouse-over-popover" onClose={handleDialog} open={true}>
      <Box className={styles.muscModal}>
        <IconButton onClick={handleDialog}>
          <CloseIcon />
        </IconButton>
        <MuscQuickStartGuideText />
      </Box>
    </Modal>
  );
}
